import { AnimatedButton } from '@ts/components/AnimatedButton';
import { scrollToElement } from '@ts/utils';

export const init = () => {
    setAnimatedButtons();
    setHTMXListeners();
    setErrorStateListeners();
}

const setErrorStateListeners = () =>{
    document.body.addEventListener('validation:failed', function(event) {
        const form = event.target;
        const btn = form.querySelector('.animated-button'); 
        if (btn) {
            const saveBtn = AnimatedButton.getButton(btn.id);
            if (saveBtn) handleBtnErrorState(saveBtn);
        }
    });
}

 const setAnimatedButtons = () => {
    const saveButtons = AnimatedButton.create('.animated-button');
}

const handleBtnErrorState = (btn) => {
    btn.setState('error', 1500, function() {
       btn.setState('default');
    });
}   

const handleBtnSavedState = (btn) => {
    btn.setState('saved', 1000, function() {
        btn.setState('default');
    });
}   

const setHTMXListeners = () => {

    let validationFailed;
    let isRedirect = false;
    let savedLabel;

    document.body.addEventListener('htmx:beforeOnLoad', function (event) {
        const xhr = event.detail.xhr;
        validationFailed = xhr.getResponseHeader('x-validation-status')?.toLowerCase() === 'false';
        isRedirect = !!xhr.getResponseHeader('HX-Redirect');
    });

    document.body.addEventListener('htmx:afterSettle', function(event) {
        const triggerElement = event.detail.requestConfig.triggeringEvent?.submitter || event.detail.requestConfig.elt;
        if (!triggerElement) return;
        setAnimatedButtons();
        const saveBtn = AnimatedButton.getButton(triggerElement.id);
        if (!saveBtn) return;
        if (validationFailed) {
            handleBtnErrorState(saveBtn);
            scrollToFirstServerError();
            return;
        }
        if (!isRedirect && !validationFailed) {
            handleBtnSavedState(saveBtn);
        }
    });
    
}

const scrollToFirstServerError = () => {
    const errorSpan = document.querySelector('.field-validation-error');
    if (errorSpan && errorSpan.textContent.trim()) {
        scrollToElement(errorSpan);
    }
}